export default __webpack_public_path__ + "media/images/home/living_interior_design-65ee33256addf78ca84cb8a884ffd542.webp";